'use strict'

export default function (): void {
  const bestOfferEl = document.getElementById('product-best-offer')
  const resultEl = document.querySelector('.product__section.product__results')

  if (!resultEl || !bestOfferEl) {
    return
  }

  const rangeObserver = new window.IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        bestOfferEl.classList.add('best-offer--hidden')
      } else {
        bestOfferEl.classList.remove('best-offer--hidden')
      }
    },
    {
      rootMargin: '-50% 0% -30% 0%',
    }
  )

  window.addEventListener('resize', function () {
    rangeObserver.unobserve(resultEl)
    rangeObserver.observe(resultEl)
  })

  rangeObserver.observe(resultEl)
}
